import React from 'react';
import { useTranslation } from 'react-i18next';
import { SelectSingleControlled } from '../../../../../components/form/Selects/SelectSingleControlled';
import { useSkillCategoriesQuery } from '../../../__generated__/graphql';

type Props = {
  name: string;
};

export const SkillCategoryPicker: React.FC<Props> = ({ name }) => {
  const { t } = useTranslation();
  const { data } = useSkillCategoriesQuery();

  const options = React.useMemo(
    () =>
      (data?.skillCategories ?? [])
        .slice()
        .sort((a, b) => a.Name.localeCompare(b.Name))
        .map((c) => ({ value: c.Id, label: c.Name })),
    [data],
  );

  return (
    <SelectSingleControlled
      name={name}
      options={options}
      placeholder={t('skills.category.pickerPlaceholder')}
    />
  );
};
